import React, { Component } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import { Row, Col, Card, CardBody, Button, Label, CardTitle } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { success, info, error, warning, clear } from "toastr";
import {
  addCashPaymentAPI,
  addRemainderAPI,
  getBanks,
  getOrganizatioanApi,
  getPaymentAPI,
  getRemainderByIdAPI,
  updateCashPaymentAPI,
} from "api";
import moment from "moment/moment";
import { trashmails } from "common/data";
// Table data

class PaymentCash extends Component {
  constructor(props) {
    console.log(props);
    super(props);

    this.state = {
      props: props?.location?.query
        ? props.location.query
        : { isEdit: 1, data: null },
      totalAmount: 0,
      totalPaidable: 0,
      totalPaid: "",
      paymentStatus: "",
      isUpdate: true,
      paymentDetailList: [],
      remainderDetailList: [],
      bankList: [],
      paymentMethod: 1,
      cashAmount: 0,
      discountedAmount: 0,
      organizationDetail: {},
      editPaymentDetail: [],
      bankName: "",
      addDate: "",
      paymentId: "",
      accountNumber: "",
      chequeNumber: "",
      ifscCode: "",
    };
  }
  calculation = async () => {
    const data = await getPaymentAPI({
      id: this.state.props.data.id,
      page: null,
      limit: null,
    });
    if (data && data.data) {
      this.setState({
        paymentDetailList: data.data,
        cashAmount: 0,
        bankName: "",
        paymentStatus: "",
        addDate: "",
        accountNumber: "",
        chequeNumber: "",
        ifscCode: "",
      });
    }
    let cost = 0;
    this.state.props.data.ledgerDetails.map(x => {
      cost +=
        x.mainJangad.rate *
        x.mainJangad.jangads.reduce((prev, current) => {
          return prev.cycle < current.cycle ? prev : current;
        }).weight;
    });

    if (this.state.props.data.paymentType == "Bank") {
      console.log(
        this.state.props.data.discount == null
          ? cost -
              (cost / 100) * parseInt(this.state.organizationDetail.tdsRate)
          : cost -
              (cost / 100) * parseInt(this.state.organizationDetail.tdsRate) -
              this.state.props.data.discount
      );
      this.setState({
        totalAmount: cost,
        totalPaidable:
          this.state.props.data.discount == null
            ? cost -
              (cost / 100) * parseInt(this.state.organizationDetail.tdsRate)
            : cost -
              (cost / 100) * parseInt(this.state.organizationDetail.tdsRate) -
              this.state.props.data.discount,
        discountedAmount:
          (cost / 100) * parseInt(this.state.organizationDetail.tdsRate),
      });
    } else {
      this.setState({
        totalAmount: cost,
        totalPaidable:
          this.state.props.data.discount == null
            ? cost
            : cost - this.state.props.data.discount,
        discountedAmount: 0,
      });
    }
    let totalCost = 0;
    if (data == undefined) {
      totalCost = 0;
    } else {
      data.data.map(x => {
        return parseInt((totalCost += parseInt(x.amount)));
      });
    }
    this.setState({
      totalPaid: totalCost,
    });
  };
  async componentDidMount() {
    if (this.state.props.data.paymentType == "NA") {
      warning("Please First Select Payment Type");
    }
    let organization = await getOrganizatioanApi();
    if (organization) {
      this.setState({
        organizationDetail: organization.data.organizations[0],
      });
    }

    const bank = await getBanks();
    if (bank && bank.data) {
      this.setState({
        bankList: bank.data,
      });
    }
    const data = await getPaymentAPI({
      id: this.state.props.data.id,
      page: null,
      limit: null,
    });
    if (data && data.data) {
      this.setState({
        paymentDetailList: data == undefined ? [] : data.data,
      });
      let totalCost = 0;
      if (data == undefined) {
        totalCost = 0;
      } else {
        data.data.map(x => {
          return parseInt((totalCost += parseInt(x.amount)));
        });
      }
      this.setState({
        totalPaid: totalCost,
      });
    }
    this.calculation();
    const remainder = await getRemainderByIdAPI({
      page: null,
      limit: null,
      ledgerId: this.state.props.data.id,
    });
    if (remainder && remainder.data) {
      this.setState({
        remainderDetailList: remainder == undefined ? [] : remainder.data,
      });
    }
  }

  handleSubmit1 = async values => {
    if (this.state.paymentMethod == 1) {
      let temp2 = {
        amount: parseInt(this.state.cashAmount),
        remainingAmount: parseFloat(
          (
            this.state.totalPaidable -
            this.state.totalPaid -
            parseInt(this.state.cashAmount)
          ).toFixed(2)
        ),
        paymentMethod: 1,
        ledgerId: this.state.props.data.id,
        payDate: values.addDate,
        paymentStatus:
          parseFloat(
            (
              this.state.totalPaidable -
              this.state.totalPaid -
              parseInt(this.state.cashAmount)
            ).toFixed(2)
          ) <= 0
            ? "Paid"
            : "PartialPaid",
      };
      const data1 = await addCashPaymentAPI(temp2);
      if (data1.success == true) {
        this.calculation();
      }
    } else if (this.state.paymentMethod == 2) {
      let temp2 = {
        accountNumber: values.accountNumber,
        chequeNumber: values.chequeNumber,
        ifscCode: values.ifscCode,
        payDate: values.addDate,
        amount: parseInt(this.state.cashAmount),
        ledgerId: this.state.props.data.id,
        remainingAmount: parseFloat(
          (
            this.state.totalPaidable -
            this.state.totalPaid -
            parseInt(this.state.cashAmount)
          ).toFixed(2)
        ),
        paymentMethod: 2,
        paymentStatus:
          parseFloat(
            (
              this.state.totalPaidable -
              this.state.totalPaid -
              parseInt(this.state.cashAmount)
            ).toFixed(2)
          ) <= 0
            ? "Paid"
            : "PartialPaid",
        // paymentStatus: values.paymentStatus
      };
      const data1 = await addCashPaymentAPI(temp2);
      if (data1.success == true) {
        this.calculation();
      }
    } else {
      let temp2 = {
        amount: parseInt(this.state.cashAmount),
        remainingAmount: parseFloat(
          (
            this.state.totalPaidable -
            this.state.totalPaid -
            parseInt(this.state.cashAmount)
          ).toFixed(2)
        ),
        paymentMethod: 3,
        payDate: values.addDate,
        ledgerId: this.state.props.data.id,
        bankId: values.bankName,
        paymentStatus:
          parseFloat(
            (
              this.state.totalPaidable -
              this.state.totalPaid -
              parseInt(this.state.cashAmount)
            ).toFixed(2)
          ) <= 0
            ? "Paid"
            : "PartialPaid",
        // paymentStatus: values.paymentStatus
      };
      const data1 = await addCashPaymentAPI(temp2);
      if (data1.success == true) {
        this.calculation();
      }
    }
  };

  update = async values => {
    if (this.state.paymentMethod == 1) {
      let id = this.state.paymentId;
      let temp2 = {
        amount: parseInt(this.state.cashAmount),
        remainingAmount: (
          this.state.totalAmount -
          this.state.totalPaid -
          parseInt(this.state.cashAmount)
        ).toFixed(2),
        paymentMethod: 1,
        ledgerId: this.state.props.data.id,
        payDate: values.addDate,
        paymentStatus: values.paymentStatus,
      };
      const data1 = await updateCashPaymentAPI({ id: id, data: temp2 });
      if (data1.success == true) {
        const data = await getPaymentAPI({
          id: this.state.props.data.id,
          page: null,
          limit: null,
        });
        this.setState({
          paymentDetailList: data.data,
        });
        let cost = 0;
        this.state.props.data.ledgerDetails.map(x => {
          cost +=
            x.mainJangad.rate *
            x.mainJangad.jangads.reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight;
        });
        this.setState({
          totalAmount: cost,
        });
        let totalCost = 0;
        if (data == undefined) {
          totalCost = 0;
        } else {
          data.data.map(x => {
            return parseInt((totalCost += parseInt(x.amount)));
          });
        }
        this.setState({
          totalPaid: totalCost,
        });
      }
    } else if (this.state.paymentMethod == 2) {
      let id = this.state.paymentId;
      let temp2 = {
        accountNumber: values.accountNumber,
        chequeNumber: values.chequeNumber,
        ifscCode: values.ifscCode,
        payDate: values.addDate,
        amount: parseInt(this.state.cashAmount),
        ledgerId: this.state.props.data.id,
        remainingAmount: (
          this.state.totalAmount -
          this.state.totalPaid -
          parseInt(this.state.cashAmount)
        ).toFixed(2),
        paymentMethod: 2,
        paymentStatus: values.paymentStatus,
      };
      const data1 = await updateCashPaymentAPI({ id: id, data: temp2 });
      if (data1.success == true) {
        const data = await getPaymentAPI({
          id: this.state.props.data.id,
          page: null,
          limit: null,
        });
        this.setState({
          paymentDetailList: data.data,
        });
        let cost = 0;
        this.state.props.data.ledgerDetails.map(x => {
          cost +=
            x.mainJangad.rate *
            x.mainJangad.jangads.reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight;
        });
        this.setState({
          totalAmount: cost,
        });
        let totalCost = 0;
        if (data == undefined) {
          totalCost = 0;
        } else {
          data.data.map(x => {
            return parseInt((totalCost += parseInt(x.amount)));
          });
        }
        this.setState({
          totalPaid: totalCost,
        });
      }
    } else {
      let id = this.state.paymentId;
      let temp2 = {
        amount: parseInt(this.state.cashAmount),
        remainingAmount: (
          this.state.totalAmount -
          this.state.totalPaid -
          parseInt(this.state.cashAmount)
        ).toFixed(2),
        paymentMethod: 3,
        payDate: values.addDate,
        ledgerId: this.state.props.data.id,
        bankId: values.bankName,
        paymentStatus: values.paymentStatus,
      };
      const data1 = await updateCashPaymentAPI({ id: id, data: temp2 });
      if (data1.success == true) {
        const data = await getPaymentAPI({
          id: this.state.props.data.id,
          page: null,
          limit: null,
        });
        this.setState({
          paymentDetailList: data.data,
        });
        let cost = 0;
        this.state.props.data.ledgerDetails.map(x => {
          cost +=
            x.mainJangad.rate *
            x.mainJangad.jangads.reduce((prev, current) => {
              return prev.cycle < current.cycle ? prev : current;
            }).weight;
        });
        this.setState({
          totalAmount: cost,
        });
        let totalCost = 0;
        if (data == undefined) {
          totalCost = 0;
        } else {
          data.data.map(x => {
            return parseInt((totalCost += parseInt(x.amount)));
          });
        }
        this.setState({
          totalPaid: totalCost,
        });
      }
    }
  };

  handleSubmit = async values => {
    let temp = {
      notes: values.remainderNotes,
      time: values.remainderTime,
      date: values.remainderDate,
      ledgerId: this.state.props.data.id,
    };
    const data = await addRemainderAPI(temp);
    if (data.success == true) {
      const remainder = await getRemainderByIdAPI({
        page: null,
        limit: null,
        ledgerId: this.state.props.data.id,
      });
      if (remainder && remainder.data)
        this.setState({
          remainderDetailList: remainder.data,
        });
    }
  };

  render() {
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No")}`,
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
      },
      {
        dataField: "paymentMethod",
        text: `${this.props.t("Payment Method")}`,
        formatter: (cell, row) => {
          if (cell == 1) {
            return "Cash";
          } else if (cell == 2) {
            return "Cheque";
          } else {
            return "RTGS & UPI";
          }
        },
      },
      {
        dataField: "payDate",
        text: `${this.props.t("Payment Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD-MM-YYYY");
        },
      },
      {
        dataField: "amount",
        text: `${this.props.t("Payment Amount")}`,
      },
      {
        dataField: "remainingAmount",
        text: `${this.props.t("Remaining Amount")}`,
      },
      {
        dataField: "viewDetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <button
              type="button"
              onClick={() => {
                this.setState({
                  paymentId: row.id,
                  totalAmount: this.state.totalAmount,
                  cashAmount: row.amount,
                  isUpdate: false,
                  paymentMethod: row.paymentMethod,
                  bankName: row.bankId,
                  addDate: moment(row.payDate).format("yyyy-MM-DD"),
                  accountNumber: row.accountNumber,
                  chequeNumber: row.chequeNumber,
                  ifscCode: row.ifscCode,
                });
              }}
              className="py-2 px-2 border-0 rounded ms-2"
            >
              <img src="images/dashboard-images/view.svg" />
            </button>
          </div>
        ),
      },
    ];
    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No")}`,
        hidden: true,
      },
      {
        dataField: "ledgerId",
        text: `${this.props.t("Ledger Id")}`,
      },
      {
        dataField: "notes",
        text: `${this.props.t("Notes")}`,
      },
      {
        dataField: "date",
        text: `${this.props.t("Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD-MM-YYYY");
        },
      },
      {
        dataField: "time",
        text: "Time",
      },
    ];

    document.title = "transaction-history";
    return (
      <React.Fragment>
        <div className="page-content">
          <Formik
            enableReinitialize={true}
            initialValues={
              this.state.paymentMethod == 1
                ? {
                    totalAmount: this.state.totalAmount,
                    totalPaid: this.state.totalPaid,
                    cashAmount: this.state.cashAmount,
                    addDate: this.state.addDate,
                    // paymentStatus: this.state.paymentStatus,
                  }
                : this.state.paymentMethod == 2
                ? {
                    partyName:
                      this.state.props.data.partyId == null
                        ? this.state.props.data.factory.name
                        : this.state.props.data.party.name,
                    accountNumber: this.state.accountNumber,
                    chequeNumber: this.state.chequeNumber,
                    ifscCode: this.state.ifscCode,
                    totalAmount: this.state.totalAmount,
                    totalPaid: this.state.totalPaid,
                    cashAmount: this.state.cashAmount,
                    addDate: this.state.addDate,
                    // paymentStatus: this.state.paymentStatus,
                  }
                : {
                    bankName: this.state.bankName,
                    totalAmount: this.state.totalAmount,
                    totalPaid: this.state.totalPaid,
                    cashAmount: this.state.cashAmount,
                    addDate: this.state.addDate,
                    // paymentStatus: this.state.paymentStatus,
                  }
            }
            validationSchema={Yup.object().shape(
              this.state.paymentMethod == 1
                ? {
                    totalAmount: Yup.number().notRequired(),
                    totalPaid: Yup.number().notRequired(),
                    cashAmount: Yup.number()
                      .min(1)
                      .max(
                        this.state.props.data.discount == null
                          ? this.state.totalAmount - this.state.totalPaid
                          : this.state.totalAmount -
                              this.state.totalPaid -
                              this.state.props.data.discount
                      )
                      .required("This Value is Required"),
                    addDate: Yup.string().required("This Value is Required"),
                    // paymentStatus: Yup.string().required("This Value is Required"),
                  }
                : this.state.paymentMethod == 2
                ? {
                    partyName: Yup.string().notRequired(),
                    accountNumber: Yup.string().required(
                      "This Value is Required"
                    ),
                    chequeNumber: Yup.string().required(
                      "This Value is Required"
                    ),
                    ifscCode: Yup.string().required("This Value is Required"),
                    totalAmount: Yup.number().required(
                      "This Value is Required"
                    ),
                    totalPaid: Yup.number().notRequired(),
                    cashAmount: Yup.number()
                      .min(1)
                      .max(
                        this.state.props.data.discount == null
                          ? this.state.totalAmount - this.state.totalPaid
                          : this.state.totalAmount -
                              this.state.totalPaid -
                              this.state.props.data.discount
                      )
                      .required("This Value is Required"),
                    addDate: Yup.string().required("This Value is Required"),
                    // paymentStatus: Yup.string().required("This Value is Required"),
                  }
                : {
                    bankName: Yup.string().required("This Value is Required"),
                    totalAmount: Yup.number().required(
                      "This Value is Required"
                    ),
                    totalPaid: Yup.number().notRequired(),
                    cashAmount: Yup.number()
                      .min(1)
                      .max(
                        this.state.props.data.discount == null
                          ? this.state.totalAmount - this.state.totalPaid
                          : this.state.totalAmount -
                              this.state.totalPaid -
                              this.state.props.data.discount
                      )
                      .required("This Value is Required"),
                    addDate: Yup.string().required("This Value is Required"),
                    // paymentStatus: Yup.string().required("This Value is Required"),
                  }
            )}
            onSubmit={values => {}}
          >
            {({ errors, status, touched, values, validateForm }) => (
              <Form className="needs-validation">
                <Row className="px-4">
                  <h3 className="text-black fw-bold text-uppercase pb-4">
                    {this.props.t("ADD PAYMENT")} - {this.state.props.data.id}
                  </h3>
                  <div className="row">
                    <div className="col-xl-2">
                      <div
                        className={
                          this.state.paymentMethod == 1
                            ? "bg-primary mt-3 py-4 rounded"
                            : "bg-white mt-3 py-4 rounded shadow"
                        }
                        onClick={() =>
                          this.setState({
                            paymentMethod: 1,
                            cashAmount: 0,
                            addDate: "",
                            accountNumber: "",
                            paymentStatus: "",
                            isUpdate: true,
                          })
                        }
                      >
                        <img
                          src={
                            this.state.paymentMethod == 1
                              ? "images/dashboard-images/cashpaymenthover.svg"
                              : "images/dashboard-images/cashpayment.svg"
                          }
                          alt="cashpayment"
                          className="mx-auto d-block"
                        />
                        <p
                          className={
                            this.state.paymentMethod == 1
                              ? "text-center text-white fs-4 pt-2"
                              : "text-center fs-4 pt-2 fw-bold"
                          }
                        >
                          {this.props.t("Cash")}
                        </p>
                      </div>
                      <div
                        className={
                          this.state.paymentMethod == 2
                            ? "bg-primary mt-3 py-4 rounded"
                            : "bg-white mt-3 py-4 rounded shadow"
                        }
                        onClick={() =>
                          this.setState({
                            paymentMethod: 2,
                            cashAmount: 0,
                            addDate: "",
                            paymentStatus: "",
                            accountNumber: "",
                            isUpdate: true,
                          })
                        }
                      >
                        <img
                          src={
                            this.state.paymentMethod == 2
                              ? "images/dashboard-images/chequehover.svg"
                              : "images/dashboard-images/cheque.svg"
                          }
                          alt="cashpayment"
                          className="mx-auto d-block"
                        />
                        <p
                          className={
                            this.state.paymentMethod == 2
                              ? "text-center text-white fs-4 pt-2"
                              : "text-center fs-4 pt-2 fw-bold"
                          }
                        >
                          {this.props.t("Cheque")}
                        </p>
                      </div>
                      <div
                        className={
                          this.state.paymentMethod == 3
                            ? "bg-primary mt-3 py-4 rounded"
                            : "bg-white mt-3 py-4 rounded shadow"
                        }
                        onClick={() =>
                          this.setState({
                            paymentMethod: 3,
                            cashAmount: 0,
                            accountNumber: "",
                            addDate: "",
                            paymentStatus: "",
                            isUpdate: true,
                          })
                        }
                      >
                        <img
                          src={
                            this.state.paymentMethod == 3
                              ? "images/dashboard-images/googlepayhover.svg"
                              : "images/dashboard-images/googlepay.svg"
                          }
                          alt="cashpayment"
                          className="mx-auto d-block"
                        />
                        <p
                          className={
                            this.state.paymentMethod == 3
                              ? "text-center text-white fs-4 pt-2"
                              : "text-center fs-4 pt-2 fw-bold"
                          }
                        >
                          {this.props.t("RTGS & UPI")}
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-10">
                      <div className="row pt-5 pb-3">
                        <div className="col-xxl-4 text-xxl-start text-center">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="totalAmount"
                              className="fs-5 fw-bold col-xxl-6 col-xl-12 col-4 px-0 px-md-3 text-black"
                            >
                              {this.props.t("Total Invoice Amount")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <span className="fs-5 text-black border-1 bg-white py-1 border-end-0 prefix-radius ps-2 d-inline">
                                ₹
                              </span>
                              <Field
                                className={
                                  "py-1 ps-1 prefix-right border-start-0 fs-5 w-100" +
                                  (errors.totalAmount && touched.totalAmount
                                    ? " is-invalid"
                                    : "")
                                }
                                value={this.state.totalAmount.toFixed(2)}
                                readOnly={true}
                                type="text"
                                name="totalAmount"
                              />
                              <ErrorMessage
                                name="totalAmount"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-4 text-xxl-end text-center">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="totalPaid"
                              className="fs-5 fw-bold col-xxl-6 col-xl-12 col-4 px-0 px-md-3 text-black"
                            >
                              {this.props.t("Total Paid")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <span className="fs-5 text-black border-1 bg-white py-1 border-end-0 prefix-radius ps-2 d-inline">
                                ₹
                              </span>
                              <Field
                                className={
                                  "py-1 ps-1 prefix-right border-start-0 fs-5 w-100" +
                                  (errors.totalPaid && touched.totalPaid
                                    ? " is-invalid"
                                    : "")
                                }
                                value={this.state.totalPaid}
                                readOnly={true}
                                type="number"
                                onWheel={e => e.target.blur()}
                                name="totalPaid"
                              />
                              <ErrorMessage
                                name="totalPaid"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-4 text-xxl-end text-center">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="totalPending"
                              className="fs-5 col-xxl-6 col-xl-12 col-4 fw-bold px-0 px-md-3 text-black"
                            >
                              {this.props.t("Total Pending")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <span className="fs-5 text-black border-1 bg-white py-1 border-end-0 prefix-radius ps-2 d-inline">
                                ₹
                              </span>
                              <Field
                                className={
                                  "py-1 ps-1 prefix-right border-start-0 fs-5 w-100" +
                                  (errors.totalPending && touched.totalPending
                                    ? " is-invalid"
                                    : "")
                                }
                                value={parseFloat(
                                  (
                                    this.state.totalPaidable -
                                    this.state.totalPaid
                                  ).toFixed(2)
                                )}
                                readOnly={true}
                                type="number"
                                onWheel={e => e.target.blur()}
                                name="totalPending"
                              />
                              <ErrorMessage
                                name="totalPending"
                                component="div"
                                className="invalid-feedback d-block"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xxl-4 text-xxl-start text-center pb-3">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="tdsRate"
                              className="fs-5 col-xxl-6 col-xl-12 col-4 fw-bold px-0 px-md-3 text-black"
                            >
                              {this.props.t("TDS Rate")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <Field
                                className={
                                  "py-1 prefix-radius1 ps-1 fs-5 w-100" +
                                  (errors.tdsRate && touched.tdsRate
                                    ? " is-invalid"
                                    : "")
                                }
                                value={
                                  Object.keys(this.state.organizationDetail)
                                    .length
                                    ? this.state.organizationDetail.tdsRate +
                                      " %"
                                    : ""
                                }
                                readOnly={true}
                                type="text"
                                onWheel={e => e.target.blur()}
                                name="tdsRate"
                              />
                              <ErrorMessage
                                name="tdsRate"
                                component="div"
                                className="invalid-feedback d-block"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-4 text-xxl-end text-center pb-3">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="tdsRate"
                              className="fs-5 col-xxl-6 col-xl-12 col-4 fw-bold px-0 px-md-3 text-black"
                            >
                              {this.props.t("TDS Amount")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <span className="fs-5 text-black border-1 bg-white py-1 border-end-0 prefix-radius ps-2 d-inline">
                                ₹
                              </span>
                              <Field
                                className="py-1 ps-1 prefix-right border-start-0 fs-5 w-100"
                                value={this.state.discountedAmount}
                                readOnly={true}
                                type="text"
                                onWheel={e => e.target.blur()}
                                name="tdsRate"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-4 text-xxl-end text-center pb-3">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="tdsRate"
                              className="fs-5 col-xxl-6 col-xl-12 col-4 fw-bold px-0 px-md-3 text-black"
                            >
                              {this.props.t("Paidable Amount")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <span className="fs-5 text-black border-1 bg-white py-1 border-end-0 prefix-radius ps-2 d-inline">
                                ₹
                              </span>
                              <Field
                                className="py-1 ps-1 prefix-right border-start-0 fs-5 w-100"
                                value={this.state.totalPaidable.toFixed(2)}
                                readOnly={true}
                                type="text"
                                onWheel={e => e.target.blur()}
                                name="tdsRate"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xxl-4 text-xxl-start text-center pb-3">
                          <div className="row d-flex align-items-center pt-3 pt-xxl-0">
                            <Label
                              htmlFor="tdsRate"
                              className="fs-5 col-xxl-6 col-xl-12 col-4 fw-bold px-0 px-md-3 text-black"
                            >
                              {this.props.t("Discounted Amount")}:
                            </Label>
                            <div className="col-xxl-5 col-xl-12 col-8 d-flex px-0">
                              <Field
                                className="py-1 prefix-radius1  ps-1 fs-5 w-100"
                                value={
                                  this.state.props.data.discount == null
                                    ? 0
                                    : this.state.props.data.discount
                                }
                                readOnly={true}
                                type="text"
                                onWheel={e => e.target.blur()}
                                name="tdsRate"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.paymentMethod == 1 ? (
                        <div className="row ps-3">
                          <div className="bg-white py-5">
                            <h2 className="fw-bold text-black">
                              {this.props.t("Add Cash")}
                            </h2>
                            <div className="row py-3">
                              <div className="col-md-2">
                                <Label
                                  htmlFor="cashAmount"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Amount")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.cashAmount && touched.cashAmount
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.cashAmount}
                                  onChange={e => {
                                    this.setState({
                                      cashAmount: e.target.value,
                                    });
                                  }}
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cashAmount"
                                />
                                <ErrorMessage
                                  name="cashAmount"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-2">
                                <Label htmlFor="addDate" className="fs-4 pe-5">
                                  {this.props.t("Date")}:
                                </Label>
                              </div>
                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.addDate && touched.addDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.addDate}
                                  onChange={e => {
                                    this.setState({
                                      addDate: e.target.value,
                                    });
                                  }}
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  max={moment().format("YYYY-MM-DD")}
                                  type="date"
                                  name="addDate"
                                />
                                <ErrorMessage
                                  name="addDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {/* <div className="row pt-3">
                              <div className="col-md-2">
                                <Label htmlFor="paymentStatus" className="fs-4 pe-5">
                                  {this.props.t("Payment Stauts")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5 form-select" +
                                    (errors.paymentStatus && touched.paymentStatus
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.isUpdate == true ? false : true}
                                  value={this.state.paymentStatus}
                                  onChange={e => {
                                    this.setState({
                                      paymentStatus: e.target.value,
                                    });
                                  }}
                                  name="paymentStatus"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="Pending">
                                    Pending
                                  </option>
                                  <option value="Paid">
                                    Paid
                                  </option>
                                  <option value="Refund">
                                    Refund
                                  </option>
                                  <option value="Chargeback	">
                                    Chargeback	
                                  </option>
                                  <option value="Partial">
                                    Partial	
                                  </option>
                                 
                                </Field>
                                <ErrorMessage
                                  name="paymentStatus"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                          </div>
                        </div>
                      ) : this.state.paymentMethod == 2 ? (
                        <div className="row ps-3">
                          <div className="bg-white py-5">
                            <h2 className="fw-bold text-black">
                              {this.props.t("Add Cheque Details")}
                            </h2>
                            <div className="row py-3">
                              <div className="col-md-3">
                                <Label
                                  htmlFor="partyName"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Name")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.partyName && touched.partyName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  value={
                                    this.state.props.data.partyId == null
                                      ? this.state.props.data.factory.name
                                      : this.state.props.data.party.name
                                  }
                                  readOnly={true}
                                  name="partyName"
                                />
                                <ErrorMessage
                                  name="partyName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row py-3">
                              <div className="col-md-3">
                                <Label
                                  htmlFor="accountNumber"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Account Number")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.accountNumber &&
                                    touched.accountNumber
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.accountNumber}
                                  onChange={e => {
                                    this.setState({
                                      accountNumber: e.target.value,
                                    });
                                  }}
                                  type="text"
                                  name="accountNumber"
                                />
                                <ErrorMessage
                                  name="accountNumber"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row py-3">
                              <div className="col-md-3">
                                <Label
                                  htmlFor="chequeNumber"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Cheque Number")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.chequeNumber && touched.chequeNumber
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.chequeNumber}
                                  onChange={e => {
                                    this.setState({
                                      chequeNumber: e.target.value,
                                    });
                                  }}
                                  type="text"
                                  name="chequeNumber"
                                />
                                <ErrorMessage
                                  name="chequeNumber"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row py-3">
                              <div className="col-md-3">
                                <Label htmlFor="ifscCode" className="fs-4 pe-5">
                                  {this.props.t("IFSC Code")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.ifscCode && touched.ifscCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.ifscCode}
                                  onChange={e => {
                                    this.setState({
                                      ifscCode: e.target.value,
                                    });
                                  }}
                                  type="text"
                                  name="ifscCode"
                                />
                                <ErrorMessage
                                  name="ifscCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-3">
                                <Label htmlFor="addDate" className="fs-4 pe-5">
                                  {this.props.t("Date")}:
                                </Label>
                              </div>
                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.addDate && touched.addDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.addDate}
                                  onChange={e => {
                                    this.setState({
                                      addDate: e.target.value,
                                    });
                                  }}
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  type="date"
                                  name="addDate"
                                />
                                <ErrorMessage
                                  name="addDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row py-3">
                              <div className="col-md-3">
                                <Label
                                  htmlFor="cashAmount"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Amount")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.cashAmount && touched.cashAmount
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.cashAmount}
                                  onChange={e => {
                                    this.setState({
                                      cashAmount: e.target.value,
                                    });
                                  }}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cashAmount"
                                />
                                <ErrorMessage
                                  name="cashAmount"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {/* <div className="row pt-3">
                              <div className="col-md-3">
                                <Label htmlFor="paymentStatus" className="fs-4 pe-5">
                                  {this.props.t("Payment Stauts")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5 form-select" +
                                    (errors.paymentStatus && touched.paymentStatus
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.isUpdate == true ? false : true}
                                  value={this.state.paymentStatus}
                                  onChange={e => {
                                    this.setState({
                                      paymentStatus: e.target.value,
                                    });
                                  }}
                                  name="paymentStatus"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="Pending">
                                    Pending
                                  </option>
                                  <option value="Paid">
                                    Paid
                                  </option>
                                  <option value="Refund">
                                    Refund
                                  </option>
                                  <option value="Chargeback	">
                                    Chargeback	
                                  </option>
                                  <option value="Partial">
                                    Partial	
                                  </option>
                                 
                                </Field>
                                <ErrorMessage
                                  name="paymentStatus"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                          </div>
                        </div>
                      ) : (
                        <div className="row ps-3">
                          <div className="bg-white py-5">
                            <h2 className="fw-bold text-black">
                              {this.props.t(
                                "Add Transfer Detail (RTGS & UPI Pay)"
                              )}
                            </h2>
                            <div className="row pt-3">
                              <div className="col-md-2">
                                <Label htmlFor="bankName" className="fs-4 pe-5">
                                  {this.props.t("Bank Name")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5 form-select" +
                                    (errors.bankName && touched.bankName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.bankName}
                                  onChange={e => {
                                    this.setState({
                                      bankName: e.target.value,
                                    });
                                  }}
                                  name="bankName"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.bankList.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="bankName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row py-3">
                              <div className="col-md-2">
                                <Label
                                  htmlFor="cashAmount"
                                  className="fs-4 pe-5"
                                >
                                  {this.props.t("Amount")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.cashAmount && touched.cashAmount
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.cashAmount}
                                  onChange={e => {
                                    this.setState({
                                      cashAmount: e.target.value,
                                    });
                                  }}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="cashAmount"
                                />
                                <ErrorMessage
                                  name="cashAmount"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-2">
                                <Label htmlFor="addDate" className="fs-4 pe-5">
                                  {this.props.t("Date")}:
                                </Label>
                              </div>
                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5" +
                                    (errors.addDate && touched.addDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={
                                    this.state.isUpdate == true ? false : true
                                  }
                                  value={this.state.addDate}
                                  onChange={e => {
                                    this.setState({
                                      addDate: e.target.value,
                                    });
                                  }}
                                  type="date"
                                  name="addDate"
                                />
                                <ErrorMessage
                                  name="addDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {/* <div className="row pt-3">
                              <div className="col-md-2">
                                <Label htmlFor="paymentStatus" className="fs-4 pe-5">
                                  {this.props.t("Payment Stauts")}:
                                </Label>
                              </div>

                              <div className="col-md-8">
                                <Field
                                  className={
                                    "py-1 ps-2 pe-4 form-control rounded fs-5 form-select" +
                                    (errors.paymentStatus && touched.paymentStatus
                                      ? " is-invalid"
                                      : "")
                                  }
                                  value={this.state.paymentStatus}
                                  onChange={e => {
                                    this.setState({
                                      paymentStatus: e.target.value,
                                    });
                                  }}
                                  disabled={this.state.isUpdate == true ? false : true}
                                  name="paymentStatus"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="Pending">
                                    Pending
                                  </option>
                                  <option value="Paid">
                                    Paid
                                  </option>
                                  <option value="Refund">
                                    Refund
                                  </option>
                                  <option value="Chargeback	">
                                    Chargeback	
                                  </option>
                                  <option value="Partial">
                                    Partial	
                                  </option>
                                 
                                </Field>
                                <ErrorMessage
                                  name="paymentStatus"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-lg-end py-5 text-center no-print">
                      {this.state.isUpdate ? (
                        <>
                          <Button
                            color="primary"
                            className="fs-4 px-5 ms-2"
                            type="submit"
                            onClick={() => {
                              validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit1(values);
                                  }
                                })
                                .catch(err => console.log(err));
                            }}
                          >
                            Save
                          </Button>
                        </>
                      ) : (
                        <>
                          {/* <Button
                            color="primary"
                            className="fs-4 px-5 ms-2"
                            type="submit"
                            onClick={() => {
                              validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.update(values);
                                  }
                                })
                                .catch(err => console.log(err));
                            }}
                          >
                            Update
                          </Button> */}
                        </>
                      )}
                    </div>
                  </div>
                </Row>
              </Form>
            )}
          </Formik>
          <Formik
            enableReinitialize={true}
            initialValues={{
              remainderDate: "",
              remainderTime: "",
              remainderNotes: "",
            }}
            validationSchema={Yup.object().shape({
              remainderDate: Yup.string().required("This Value is Required"),
              remainderTime: Yup.string().required("This Value is Required"),
              remainderNotes: Yup.string().required("This Value is Required"),
            })}
            onSubmit={values => {}}
          >
            {({ errors, status, touched, values, validateForm }) => (
              <Form className="needs-validation">
                <Row className="px-4">
                  <div className="row mx-1 mt-3 py-4 bg-white shadow">
                    <h3 className="text-black fw-bold py-2">
                      {this.props.t("Remainder")}
                    </h3>
                    <div className="col-lg-4">
                      <div className="row">
                        <div className="col-md-3">
                          <Label htmlFor="remainderDate" className="fs-4 pe-5">
                            {this.props.t("Date")}:
                          </Label>
                        </div>
                        <div className="col-md-9">
                          <Field
                            className={
                              "py-1 ps-2 form-control rounded fs-5" +
                              (errors.remainderDate && touched.remainderDate
                                ? " is-invalid"
                                : "")
                            }
                            type="date"
                            name="remainderDate"
                          />
                          <ErrorMessage
                            name="remainderDate"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-3">
                          <Label htmlFor="remainderTime" className="fs-4 pe-5">
                            {this.props.t("Time")}:
                          </Label>
                        </div>
                        <div className="col-md-9">
                          <Field
                            className={
                              "py-1 ps-2 form-control rounded fs-5" +
                              (errors.remainderTime && touched.remainderTime
                                ? " is-invalid"
                                : "")
                            }
                            type="time"
                            name="remainderTime"
                          />
                          <ErrorMessage
                            name="remainderTime"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-md-3 text-lg-center text-start">
                          <Label htmlFor="remainderNotes" className="fs-4 pe-5">
                            {this.props.t("Remainder Notes")}:
                          </Label>
                        </div>
                        <div className="col-md-9">
                          <Field
                            className={
                              "py-1 ps-2 form-control rounded fs-5" +
                              (errors.remainderNotes && touched.remainderNotes
                                ? " is-invalid"
                                : "")
                            }
                            as="textarea"
                            rows="4"
                            name="remainderNotes"
                          />
                          <ErrorMessage
                            name="remainderNotes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-lg-end py-5 text-center no-print">
                      <Button
                        color="primary"
                        className="fs-4 px-5 ms-2"
                        type="submit"
                        onClick={() => {
                          validateForm()
                            .then(data => {
                              if (Object.keys(data).length == 0) {
                                this.handleSubmit(values);
                              }
                            })
                            .catch(err => console.log(err));
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Row>
              </Form>
            )}
          </Formik>
          {this.state.paymentDetailList.length > 0 && (
            <div className="row my-5 mx-3">
              <div className="bg-white py-5">
                <h3 className="text-black fw-bold">
                  {this.props.t("Past Payment Details")}
                </h3>

                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    responsive
                    bordered={false}
                    striped={false}
                    bootstrap4={true}
                    data={this.state.paymentDetailList}
                    columns={this.columns1}
                  />
                </div>
              </div>
            </div>
          )}

          {this.state.remainderDetailList.length > 0 && (
            <div className="row mx-3">
              <div className="bg-white py-5">
                <h3 className="text-black fw-bold">
                  {this.props.t("Remainder Summary")}
                </h3>

                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    responsive
                    bordered={false}
                    striped={false}
                    bootstrap4={true}
                    data={this.state.remainderDetailList}
                    columns={this.columns2}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(PaymentCash);
